export const roundToFixed = (value?: number, digits?: number): number => {
  const roundedNumber = Number(value?.toFixed(digits || 0)) || 0;
  return roundedNumber >= 0 ? Math.abs(roundedNumber) : roundedNumber;
};

export const getCurrencyFormatter = (
  decimalPlaces: number,
  style = 'currency',
  locale = 'en-US',
  currency = 'USD'
): Intl.NumberFormat =>
  new Intl.NumberFormat(locale, {
    currency,
    style,
    minimumFractionDigits: decimalPlaces
  });

export const formatCurrency = (
  value: number | string | undefined,
  style?: 'currency' | 'decimal',
  decimalPlaces = 2
): string => {
  const numberValue = Number(value);

  if (numberValue || numberValue === 0) {
    let strVal = numberValue.toFixed(decimalPlaces);

    if (Number(strVal) === 0) {
      strVal = '0';
    }

    const formatter = getCurrencyFormatter(decimalPlaces, style);
    return formatter.format(Number(strVal));
  }

  return '';
};
